import { useEffect, useRef, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Avatar,
    Box,
    ClickAwayListener,
    Grid,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Paper,
    Popper,
    Typography,
    useMediaQuery
} from '@mui/material';

// project imports
import Transitions from 'ui-component/extended/Transitions';

// assets
import TranslateTwoToneIcon from '@mui/icons-material/TranslateTwoTone';
import useConfig from 'hooks/useConfig';
import { Translate } from '@mui/icons-material';

// ==============================|| LOCALIZATION ||============================== //

const LocalizationMenu = () => {
    const { borderRadius, locale,rtlLayout, onChangeLocale,onChangeRTL } = useConfig();

    const theme = useTheme();
    

    const [open, setOpen] = useState(false);
    const anchorRef = useRef<any>(null);
    const [language, setLanguage] = useState<string>(locale);
    const [rtl, setRTL] = useState<boolean>(rtlLayout);

    const handleListItemClick = (
        event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement, MouseEvent> | undefined,
        lng: string
    ) => {
        setLanguage(lng);
        onChangeLocale(lng);

        // console.log('lang_change',lng);
        setOpen(false);
    };



    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);

    useEffect(() => {
        setLanguage(locale);
       // console.log('locale',locale);
       const isRtl = (locale.toString() === 'he');
       setRTL(isRtl);
       onChangeRTL(isRtl);

    }, [locale]);

    return (
        <>
            <List
                component="nav"
                sx={{
                    width: '100%',
                    minWidth: 200,
                    maxWidth: 280,
                    py:0,
                    bgcolor: theme.palette.background.paper,
                    borderRadius: `${borderRadius}px`,
                    [theme.breakpoints.down('md')]: {
                        maxWidth: 250
                    },
                    '& .MuiListItemButton-root': {
                        px:3,
                        borderRadius: `${borderRadius}px`,
                        lineHeight:18,
                        '&.Mui-selected':{
                            color: theme.palette.grey[900],
                            backgroundColor: theme.palette.grey[100],
                            fontWeight:'bold'
                        },
                        '& .MuiListItemIcon-root': {
                            my: 'auto', 
                            minWidth: 36,
                            fontSize:1.5,
                            color:'inherit !important'
                        }
                    },
                   
                   
                }}
            >
                    <ListItemButton selected={language === 'he'} onClick={(event) => handleListItemClick(event, 'he')}>
                    <ListItemIcon ><Translate   /></ListItemIcon>
                    <ListItemText
                        primary={
                            <Grid container >
                                <Typography color="textPrimary">עברית</Typography>
                                <Typography variant="caption" color="textSecondary" sx={{ ml: '8px',lineHeight:1.5 }}>
                                    (HE)
                                </Typography>
                            </Grid>
                        }
                    />
                </ListItemButton>
                <ListItemButton selected={language === 'en'} onClick={(event) => handleListItemClick(event, 'en')}>
                <ListItemIcon ><Translate /></ListItemIcon>
                    <ListItemText
                        primary={
                            <Grid container>
                                <Typography color="textPrimary">English</Typography>
                                <Typography variant="caption" color="textSecondary" sx={{ ml: '8px',lineHeight:1.5 }}>
                                    (EN)
                                </Typography>
                            </Grid>
                        }
                    />
                </ListItemButton>
            </List>    
        </>
    );
};

export default LocalizationMenu;
